import React from "react";
import "./SkeletonLoader.css";

export const SkeletonCard = () => (
  <div className="skeleton-card">
    <div className="skeleton-line skeleton-title" />
    <div className="skeleton-line skeleton-text" />
    <div className="skeleton-line skeleton-text" />
    <div className="skeleton-line skeleton-text-short" />
  </div>
);

export const SkeletonHero = () => (
  <div className="skeleton-hero">
    <div className="skeleton-line skeleton-hero-title" />
    <div className="skeleton-line skeleton-hero-text" />
    <div className="skeleton-line skeleton-hero-text" />
    <div className="skeleton-buttons">
      <div className="skeleton-button" />
      <div className="skeleton-button" />
    </div>
  </div>
);

export const SkeletonPage = () => (
  <div className="skeleton-page">
    <div className="skeleton-line skeleton-page-title" />
    <div className="skeleton-line skeleton-page-text" />
    <div className="skeleton-grid">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  </div>
);

export default SkeletonPage;

